__webpack_require__.p = "https://assets.yanolja.com/platform-site/prod/8a2f792657cc574bd84f9fef59cb039820d19790/_next/";